import BaseStore from '../components/BaseStore'

export default {
  name: 'BaseCurdInfo',
  extends: BaseStore,
  computed: {
    curdInfo () {
      return this.$route.meta.curdInfo || {}
    },
    apiKey () {
      return this.curdInfo.api
    },
    idKey () {
      return this.curdInfo.id || 'id'
    },
    nameKey () {
      return this.curdInfo.name || 'name'
    },
    editName () {
      return this.curdInfo.editName
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/BaseCurdInfo.js